"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _noop = _interopRequireDefault(require("lodash/fp/noop"));
var _reactPopper = require("react-popper");
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("./constants");
var _usePopperContext2 = _interopRequireDefault(require("./usePopperContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isPositionChanged = function isPositionChanged(mutation) {
  return mutation.type === _constants.MutationStyle.type && mutation.attributeName === _constants.MutationStyle.attributeName;
};
var Popper = function Popper(_ref) {
  var refElement = _ref.refElement,
    children = _ref.children,
    _ref$skidding = _ref.skidding,
    skidding = _ref$skidding === void 0 ? 0 : _ref$skidding,
    _ref$followCursor = _ref.followCursor,
    followCursor = _ref$followCursor === void 0 ? false : _ref$followCursor,
    _ref$following = _ref.following,
    following = _ref$following === void 0 ? false : _ref$following,
    _ref$sameWidth = _ref.sameWidth,
    sameWidth = _ref$sameWidth === void 0 ? false : _ref$sameWidth,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 0 : _ref$distance,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    propClassName = _ref.className,
    propZIndex = _ref.zIndex,
    propStyle = _ref.style;
  var _usePopperContext = (0, _usePopperContext2["default"])(),
    zIndex = _usePopperContext.zIndex,
    className = _usePopperContext.className,
    style = _usePopperContext.style;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    popperElement = _useState2[0],
    setPopperElement = _useState2[1];
  var modifiers = (0, _react.useMemo)(function () {
    return [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [skidding, distance]
      }
    }, {
      name: 'sameWidth',
      enabled: sameWidth,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;
        // eslint-disable-next-line no-param-reassign
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      },
      effect: function effect(_ref3) {
        var state = _ref3.state;
        // eslint-disable-next-line no-param-reassign
        state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
      }
    }];
  }, [distance, skidding, sameWidth]);
  var instance = (0, _reactPopper.usePopper)(refElement, popperElement, {
    placement: placement,
    modifiers: modifiers
  });
  var overrideGetBoundingClientRect = (0, _react.useCallback)(function () {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function () {
      return {
        width: 0,
        height: 0,
        top: y,
        right: x,
        bottom: y,
        left: x
      };
    };
  }, []);
  var onMouseMove = (0, _react.useCallback)(function (_ref4) {
    var _instance$update;
    var x = _ref4.clientX,
      y = _ref4.clientY;
    // eslint-disable-next-line no-param-reassign
    refElement.getBoundingClientRect = overrideGetBoundingClientRect(x, y);
    (_instance$update = instance.update) === null || _instance$update === void 0 || _instance$update.call(instance);
  }, [refElement, instance, overrideGetBoundingClientRect]);
  (0, _react.useEffect)(function () {
    if (followCursor && refElement) {
      refElement.addEventListener('mousemove', onMouseMove, false);
    }
    return function () {
      if (followCursor && refElement) {
        refElement.removeEventListener('mousemove', onMouseMove, false);
      }
    };
  }, [followCursor, instance, onMouseMove, refElement]);
  var styles = instance.styles,
    attributes = instance.attributes,
    update = instance.update;
  (0, _react.useEffect)(function () {
    if (!refElement) {
      return _noop["default"];
    }
    var resizeObserver = new ResizeObserver(function () {
      update === null || update === void 0 || update();
    });
    resizeObserver.observe(refElement);
    return function () {
      resizeObserver.unobserve(refElement);
    };
  }, [update, refElement]);
  (0, _react.useEffect)(function () {
    if (!refElement) {
      return _noop["default"];
    }
    var observer;
    if (following) {
      var observerOptions = {
        attributes: true
      };
      observer = new MutationObserver(function (mutations) {
        if (mutations.some(isPositionChanged)) {
          update === null || update === void 0 || update();
        }
      });
      observer.observe(refElement, observerOptions);
    }
    return function () {
      var _observer;
      (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
    };
  }, [following, update, refElement]);
  var classes = (0, _classnames["default"])(zIndex, propZIndex, className, propClassName);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classes,
    ref: setPopperElement,
    style: _objectSpread(_objectSpread(_objectSpread({}, styles.popper), style), propStyle),
    "data-testid": "popper-root"
  }, attributes.popper), children);
};
var _default = exports["default"] = Popper;